import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpinnerServiceComponent } from '../../../shared/spinner-service/spinner-service.component';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { FieldsetModule } from 'primeng/fieldset';
import { ToastModule } from 'primeng/toast';
import { TableModule } from 'primeng/table';
import { ToolbarModule } from 'primeng/toolbar';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DropdownModule } from 'primeng/dropdown';
import { RadioButtonModule } from 'primeng/radiobutton';
import { AccordionModule } from 'primeng/accordion';
import { AvatarModule } from 'primeng/avatar';
import { BadgeModule } from 'primeng/badge';
import { CalendarModule } from 'primeng/calendar';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { CheckboxModule } from 'primeng/checkbox';
import { NfseEmissaoComponent } from './nfse-emissao/nfse-emissao.component';
import { DividerModule } from 'primeng/divider';


@NgModule({
  declarations: [NfseEmissaoComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FieldsetModule,
    TableModule,
    ToolbarModule,
    ButtonModule,
    DialogModule,
    InputTextModule,
    ToastModule,
    ConfirmDialogModule,
    NgxMaskPipe,
    NgxMaskDirective,
    DropdownModule,
    RadioButtonModule,
    AccordionModule,
    AvatarModule,
    BadgeModule,
    CalendarModule,
    InputTextareaModule,
    CheckboxModule,
    SpinnerServiceComponent,
    DividerModule
  ],
  exports: [
    NfseEmissaoComponent
  ]

})
export class NfseEmissaoModule { }
